module.exports = __webpack_public_path__ + "static/img/rotate.ee5ec34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imageViewer/icon/rotate.png
// module id = Oa9a
// module chunks = 50